import React, { createContext, useContext, ReactNode } from "react";
import { useSystemPrompt } from "../hooks/useSystemPrompt";

type SystemPromptContextType = ReturnType<typeof useSystemPrompt>;

const SystemPromptContext = createContext<SystemPromptContextType | undefined>(undefined);

interface SystemPromptProviderProps {
  children: ReactNode;
}

export const SystemPromptProvider: React.FC<SystemPromptProviderProps> = ({ children }) => {
  const systemPromptState = useSystemPrompt();

  return <SystemPromptContext.Provider value={systemPromptState}>{children}</SystemPromptContext.Provider>;
};

export const useSystemPromptContext = (): SystemPromptContextType => {
  const context = useContext(SystemPromptContext);
  if (!context) {
    throw new Error("useSystemPromptContext must be used within a SystemPromptProvider");
  }
  return context;
};
